document.querySelectorAll('section.shopify-section--main-product .product-info__accordion .accordion__content .prose ul li').forEach(li => { // to hide specification li on pdp
  const strong = li.querySelector('strong');
  if (strong && strong.textContent.trim() === '') {
    li.style.display = 'none';
  }
});

document.querySelectorAll(".accordion-group .product-info__block-item details").forEach((el, index, allAccordions) => { // close accordions automatically when the clicked one is open on pdp specification
    el.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent default summary toggle

        // Close all other accordions
        allAccordions.forEach((item) => {
            if (item !== this) {
                item.removeAttribute("open");
                item.setAttribute("aria-expanded", "false");
            }
        });

        // Open the clicked accordion
        this.setAttribute("open", "");
        this.setAttribute("aria-expanded", "true");

    });
});

(function () {
  function updateCartItem(variantId, quantity) {
    const data = { updates: {} };
    data.updates[variantId] = quantity;
    $(".loading_wait, .loading_overlay").show();
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data,
      dataType: "json",
      success: function () {
        $.getJSON("/cart.js", function (cart) {
          $(".header__cart-count .count-bubble").html(cart.item_count);
          // Update main cart page content
          if (window.location.pathname.indexOf('/cart') !== -1) {
            $.ajax({
              url: '/cart',
              type: 'GET',
              success: function (data) {
                const newCartHTML = $(data).find('.cart').html();
                $('.cart').html(newCartHTML);
                bindQuantityEvents(); // Re-bind events
              }
            });
          }
          document.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: cart.items
          }));
        }).always(() => {
          $(".loading_wait, .loading_overlay").hide();
        });
      },
      error: function () {
        $(".loading_wait, .loading_overlay").hide();
        const $input = $(`.line_changer[line_var_id="${variantId}"] input`);
        $input.val(Math.max(1, parseInt($input.val()) - 1));
        const $container = $(`.line_changer[line_var_id="${variantId}"]`);
        if (!$container.find(".cart-error").length) {
          const $msg = $(`<p class="cart-error" style="color:red;">Not Enough Inventory</p>`);
          $container.append($msg);
          setTimeout(() => $msg.fadeOut(300, () => $msg.remove()), 2000);
        }
      }
    });
  }
  function justRefresh() {
    var data = { updates: {} };
    var item_count;
    $(".loading_wait").show();
    $(".loading_overlay").show();
    jQuery.ajax({
      type: 'GET',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function (result) {
        $.when(
          jQuery.getJSON('/cart.js', function (cart) {
            item_count = cart.item_count;
            let cartData = cart.items;
            document.dispatchEvent(new CustomEvent('cart:build', {
              bubbles: true
            }));
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: cartData
            }));
          })
        ).then(function () {
          setTimeout(function () {
            if (window.location.pathname.indexOf('/cart/') == -1)
              attachCartEvents();
            $(".loading_wait").hide();
            $(".loading_overlay").hide();
          }, 2000);
        });
      }
    });
  }
  function bindQuantityEvents() {
    $(document).off("click.cart");
    $(document).on("click.cart", ".i_plus_cart", function () {
      const $line = $(this).closest(".line_changer");
      const $input = $line.find("input.quantity-input");
      const variantId = $line.attr("line_var_id");
      let current = parseInt($input.val()) || 0;
      let updated = current + 1;
      $input.val(updated);
      updateCartItem(variantId, updated);
    });
    $(document).on("click.cart", ".i_minus_cart", function () {
      const $line = $(this).closest(".line_changer");
      const $input = $line.find("input.quantity-input");
      const variantId = $line.attr("line_var_id");
      let current = parseInt($input.val()) || 1;
      let updated = Math.max(1, current - 1);
      $input.val(updated);
      updateCartItem(variantId, updated);
    });
  }
  function initCartEvents() {
    bindQuantityEvents();
    document.addEventListener("cart:change", function () {
      setTimeout(() => {
        bindQuantityEvents();
      }, 300);
    });
    document.addEventListener("cart:refresh", function () {
      setTimeout(() => {
        bindQuantityEvents();
      }, 300);
    });
  }
  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(initCartEvents, 0);
  } else {
    document.addEventListener("DOMContentLoaded", initCartEvents);
  }
  window.addEventListener("load", function () {
    setTimeout(bindQuantityEvents, 500);
  });
})();